import axios from 'axios';
import apiClient from './client.js';

/**
 * Login — pre-auth call, uses raw axios. The server sets the httpOnly session cookie;
 * rememberMe extends it to 30d (default 12h).
 * POST /api/auth/login
 */
export async function login (email, password, rememberMe = false) {
  const { data } = await axios.post('/api/auth/login', { email, password, rememberMe });
  return { user: data.user };
}

/**
 * Request a recovery mail. The answer is the same for every address.
 * POST /api/auth/recover
 */
export async function recoverPassword (email) {
  const { data } = await axios.post('/api/auth/recover', { email });
  return data;
}

/**
 * Set a new password from the recovery link's token hash.
 * POST /api/auth/reset
 */
export async function resetPassword (tokenHash, password) {
  const { data } = await axios.post('/api/auth/reset', { tokenHash, password });
  return data;
}

/**
 * Logout — authenticated call, bumps server-side tokenVersion (Phase 77 D-02).
 * Caller in useAuth.handleLogout swallows errors (best-effort per D-03) — local
 * cleanup must always run regardless of backend response.
 * POST /api/auth/logout
 */
export async function logout () {
  const { data } = await apiClient.post('/auth/logout');
  return data;
}

/**
 * Fetch current user profile.
 * GET /api/auth/me
 */
export async function fetchCurrentUser () {
  const { data } = await apiClient.get('/auth/me');
  return data?.user || null;
}
